import { useDispatch, useSelector } from "react-redux";
import {
  selectConfigs,
  selectSubstancesDisplayGrid,
} from "../../context/selectors";
import useLabels from "../../hooks/useLabels";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getDrugs, getProtocols } from "../../services/utils";
import { useEffect, useState } from "react";
import { Switch } from "../FormComponents";
import { useNavigate } from "react-router-dom";
import { toggleSubstancesDisplayGrid } from "../../context/configs/configsSlice";
import { setTreatments } from "../../context/protocols/treatmentsSlice";
import { setAnalysis } from "../../context/protocols/analysisSlice";
import { setDrugs } from "../../context/substances/drugsSlice";
import TableEdit from "../TableEdit";
import { createColumnHelper } from "@tanstack/react-table";
import TableCell from "../TableEdit/TableCell";
import EditCell from "../TableEdit/EditCell";
import { INT_FLOAT_REGEX } from "../../constants/regex";
import "./styles/index.scss";
import ProtocolTile from "../ProtocolList/ProtocolTile";
import MultipleRowsCell from "../TableEdit/MultipleRowsCell";
import { format } from "date-fns";
import {
  ConfirmationModal,
  CTA,
  groupByIngredientField,
  OperationRecap,
  Tooltip,
} from "../Generic";
import { assignDrugBatches, computeRequiredNumericQty, computeRequiredWarehouseQty, getWarehouseUnit, groupBySubstanceId } from "../../services/common";

const SubstanceList = ({
  isMobile,
  substanceType,
  substances = [],
  allSubstances = [],
  register,
  errors,
  control,
  quantities = [],
  isProtocolApplication = false,
  isSearchBar = true,
  setValue,
  getValues,
  clearErrors,
  reset,
  isCheckbox = false,
  disabledIds = [],
  drugBatches = [],
  automaticDrugBatches = [],
  totalTreatmentVolume = 0,
  operation_id = null,
}) => {
  const configs = useSelector(selectConfigs);
  const displayModeGrid = useSelector(selectSubstancesDisplayGrid);
  const dispatch = useDispatch();
  const [getLabel] = useLabels();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModifyMode, setModifyMode] = useState(-1);
  const [tableData, setTableData] = useState(substances);
  const isTreatment = substanceType === "substance";

  // const [filteredSubstances, setFilteredSubstances] = useState(allSubstances);

  // useEffect(() => {
  // setFilteredSubstances(allSubstances);
  // }, [allSubstances]);

  const columnHelper = createColumnHelper();
  const quantity = isTreatment
    ? [
        columnHelper.accessor("quantity", {
          header: getLabel("drugQuantity"),
          cell: TableCell,
          meta: {
            type: "number",
            editable: true,
            regExpPattern: INT_FLOAT_REGEX,
            isFilterDisabled: true,
            register: register,
          },
        }),
        // TO DO: se modifichi ed annulli (-) non funziona
        // columnHelper.display({   // TO DO ricontrolla, da qualche parte lo ho tolto, ma conviene utilizzare quello inserito per ultimo
        //   id: "edit",
        //   cell: EditCell,
        //   meta: {
        //     isEditable: true,
        //   },
        // }),
        columnHelper.accessor("unit", {
          header: getLabel("unit"),
          cell: TableCell,
          meta: {
            isFilterDisabled: true,
          },
        }),
      ]
    : [];
  const additionalColumns =
    substanceType === "substance" || substanceType === "treatment"
      ? [
          columnHelper.accessor(
            (row) =>
              row?.type ? getLabel(`drugType_${row.type?.toUpperCase()}`) : "",
            {
              header: getLabel("drugType"),
              cell: TableCell,
              meta: {
                isFilterDisabled: true,
              },
            }
          ),
          columnHelper.accessor(
            (row) =>
              quantities?.length > 0
                ? `${quantities[row?.index] || ""}` || ""
                : (row?.quantity || "") +
                  (row?.quantity ? " " + (row?.unit || "") : ""),
            {
              header: getLabel("drugQuantity"),
              cell: TableCell,
              meta: {
                isFilterDisabled: true,
              },
            }
          ),
          columnHelper.accessor(
            (row) =>
              Number(row?.min_range || "0") && Number(row?.max_range)
                ? `${row?.min_range || ""} - ${row?.max_range || ""} ${
                    row?.unit
                  }`
                : "",
            {
              header: getLabel("substanceRange"),
              cell: TableCell,
              meta: {
                type: "number",
                isFilterDisabled: true,
              },
            }
          ),
          columnHelper.accessor(
            (row) =>
              `${
                row?.min_temperature ? String(row?.min_temperature) : "n/a"
              } - ${
                row?.max_temperature ? String(row?.max_temperature) : "n/a"
              } \u00b0C` || "",
            {
              header: getLabel("substanceTemperature"),
              cell: TableCell,
              meta: {
                type: "number",
                isFilterDisabled: true,
              },
            }
          ),
          columnHelper.accessor("stocks", {
            header: getLabel("drugStockQuantity"),
            cell: TableCell,
            meta: {
              isFilterDisabled: true,
            },
          }),
          // columnHelper.accessor(
          //   (row) =>
          //     (row?.min_temperature || "") +
          //     (row?.min_temperature ? " " + "\u00b0 C" : ""),
          //   {
          //     header: getLabel("drugMinTemp"),
          //     cell: TableCell,
          //   }
          // ),
          // columnHelper.accessor(
          //   (row) =>
          //     (row?.max_temperature || "") +
          //     (row?.max_temperature ? " " + "\u00b0 C" : ""),
          //   {
          //     header: getLabel("drugMaxTemp"),
          //     cell: TableCell,
          //   }
          // ),

          // columnHelper.accessor(
          //   (row) =>
          //     (row?.min_range || "") + (row?.min_range ? " " + row?.unit : ""),
          //   {
          //     header: getLabel("drugMinRange"),
          //     cell: TableCell,
          //   }
          // ),

          // columnHelper.accessor(
          //   (row) =>
          //     (row?.max_range || "") + (row?.max_range ? " " + row?.unit : ""),
          //   {
          //     header: getLabel("drugMaxRange"),
          //     cell: TableCell,
          //   }
          // ),
        ]
      : [];

  const rangeColumn =
    substanceType === "analysis"
      ? [
          columnHelper.accessor("ranges", {
            header: getLabel("substanceRange"),
            cell: MultipleRowsCell,
            meta: {
              array: "items",
              selector: "ranges",
              isFilterDisabled: true,
            },
          }),
          columnHelper.accessor(
            (row) =>
              `${
                row?.min_temperature ? String(row?.min_temperature) : "n/a"
              } - ${
                row?.max_temperature ? String(row?.max_temperature) : "n/a"
              }`,
            {
              header: getLabel("substanceTemperature") + " (\u00b0C)",
              cell: TableCell,
              meta: {
                type: "number",
                isFilterDisabled: true,
              },
            }
          ),
          // columnHelper.accessor("states", {
          //   header:
          //     getLabel("substanceStates"),
          //   cell: MultipleRowsCell,
          //   meta: {
          //     array: "items",
          //     selector: "states",
          //     isFilterDisabled: true,
          //   },
          // })
        ]
      : [
          columnHelper.accessor(
            (row) =>
              row?.min_range >= 0 && row?.max_range >= 0
                ? `${row?.min_range || "0"} - ${row?.max_range || ""} ${
                    row?.unit
                  }`
                : "",
            {
              header: getLabel("substanceRange"),
              cell: TableCell,
              meta: {
                isFilterDisabled: true,
              },
            }
          ),
          columnHelper.accessor(
            (row) =>
              `${row?.recommended_quantity || ""} ${
                row?.recommended_quantity ? row?.unit || "" : ""
              }`,
            {
              header: getLabel("drugIdealQuantity"),
              cell: TableCell,
            }
          ),
        ];

  const columns = isProtocolApplication
    ? [
        columnHelper.accessor(
          (row) =>
            substanceType === "analysis"
              ? getLabel(`substance_${row?.substance_name}`)
              : row?.substance_name || row?.name,
          {
            header:
              substanceType === "analysis"
                ? getLabel("analysisName")
                : getLabel("treatmentName"),
            cell: TableCell,
            meta: {
              isFilterDisabled: true,
            },
          }
        ),
        ...rangeColumn,
        // columnHelper.accessor("unit", {
        //   header: getLabel("unit"),
        //   cell: TableCell,
        // }),
        ...quantity,
      ]
    : [
        columnHelper.accessor(
          substanceType === "substance" ? "name" : "substance_name",
          {
            header:
              substanceType === "analysis"
                ? getLabel("analysisName")
                : getLabel("treatmentName"),
            cell: TableCell,
          }
        ),
        ...additionalColumns,
      ];

  if (isProtocolApplication && (substanceType === "substance" || substanceType === "analysis")) {
    columns.push(
      columnHelper.accessor("batch_row", {
        header: getLabel("drugBatchNumber"),
        cell: TableCell,
        meta: {
          type: "select",
          control: control,
          editable: true,
          isFilterDisabled: true,
          dateFormat: configs?.shortDateFormat,
          options:
            allSubstances,
            // ?.flatMap((item) =>
            //   item?.batches?.map((batch) => ({
            //     label: `${batch?.batch_number || ""} (${format(
            //       new Date(batch?.expire_date || null),
            //       configs.shortDateFormat
            //     )})`,
            //     value: batch?.batch_number || "",
            //     stock: batch?.stock || "",
            //   }))
            // ) || [],
          options2: getValues("drug_batches") || [],
        },
      })
    );
  }

  if (isCheckbox && isProtocolApplication) {
    columns.push(
      columnHelper.display({
        id: "edit",
        cell: EditCell,
        meta: {
          isEditable: true,
        },
      })
    );
    // columns.push(columnHelper.accessor('removed', {
    //   header: getLabel("drugRemove"),
    //   cell: TableCell,
    //   meta: {
    //     type: "checkbox",
    //     editable: true,
    //     isFilterDisabled: true,
    //     // register: register,
    //   },
    // }));
  }

  const toggleDisplayMode = () => {
    dispatch(toggleSubstancesDisplayGrid());
  };

  const loadSubstances = async () => {
    const currentSubstances =
      substanceType === "substance"
        ? await getDrugs(axiosPrivate)
        : (await getProtocols(substanceType, axiosPrivate)) || [];
    dispatch(
      substanceType === "substance"
        ? setDrugs(currentSubstances)
        : substanceType === "treatment"
        ? setTreatments(currentSubstances)
        : setAnalysis(currentSubstances)
    );

    if (!isProtocolApplication) setTableData(substances);
  };

  useEffect(() => {
    const tmpSubstances = substances?.map((s) => {
      return {
        ...s,
        removed:
          disabledIds?.find(
            (dis) =>
              dis?.substance_id == s?.substance_id && dis?.removed === true
          ) !== undefined,
      };
    });
    setTableData(tmpSubstances);
    tmpSubstances?.forEach((s, i) =>
      s?.removed ? setValue(`removed.${s?.substance_id}.value`, true) : null
    );

    if (isTreatment) {
      const groupedTreatmentsBySubstanceId = groupBySubstanceId((disabledIds || [])); // trick to use operation?.treatments

      for (const t of groupedTreatmentsBySubstanceId) {
        if ((t?.drug_batches || [])?.length > 0) {
          setValue(`drug_batches.${t?.substance_id}`, t?.drug_batches);
        }
      }
    }
  }, [substances]);

  useEffect(() => {
    if (!substances || substances.length === 0) {
      loadSubstances();
    }
  }, [substanceType]);

  const filterAdditionalSubstances = () => {
    const type = substanceType === "substance" ? "treatment" : substanceType;
    const subs = [
      ...(allSubstances?.map((s, i) => {
        return {
          ...s,
          substance_name: s?.name,
          label: `${
            type === "analysis"
              ? getLabel("substance_" + s?.name) + " "
              : s?.name
          }${
            false &&
            type === "analysis" &&
            s?.colors?.length > 0 &&
            s?.colors?.length < 3
              ? ` (${getLabel("substance_color_" + s?.colors?.toString())})`
              : ""
          }`,
          substance_id: s?.substance_id,
          id: s?.substance_id,
          opType: type?.toUpperCase(),
        };
      }) || []),
    ];

    if (type === "analysis") {
      const state = getValues("protocol_id")?.state;
      const substance_ids = substances
        ?.flatMap((obj) => obj.items)
        ?.map((s) => s?.substance_id);
      const exams = allSubstances?.filter(
        (el) => !substance_ids.includes(el.id) && el?.states?.includes(state)
      );
      return [
        ...new Map(
          exams
            ?.filter((s) => s?.states?.includes(state))
            ?.map((item) => [item.substance_name, item])
        ).values(),
      ];
    } else {
      return (
        subs?.filter(
          (el) => !substances.some((f) => f.substance_id === el.id)
        ) || []
      );
    }
    // return subs;
  };

  // const {
  //   register: modalRegister,
  //   handleSubmit: modalHandleSubmit,
  //   formState: { errors: modalErrors },
  //   setValue: modalSetValue,
  //   getValues: modalGetValues,
  //   setError: modalSetError,
  //   clearErrors: modalClearErrors,
  //   control: modalControl,
  // } = useForm({
  //   defaultValues: {
  //     // day: protocol?.ay || "",
  //     // phase: protocol?.phase || "",
  //     // operation: protocol?.operation || "",
  //   },
  //   mode: "onTouched",
  // });

  const resetDrugBatchState = () => {
    drugBatches.replace([]);
    setModifyMode(-1);
  };


  const getRequiredWarehouseQty = (requiredNumericQty, warehouseUnit) => {
    if (!warehouseUnit) return 0;
    if (warehouseUnit.value === "kg") return requiredNumericQty / 1000;
    return requiredNumericQty;
  };

  const handleConfirmModal = () => {
    const drugBatchesCurrentDrug = drugBatches.fields || [];

    const substance = tableData?.find((s) => s?.substance_id === isModifyMode);
    
    const warehouseUnit = getWarehouseUnit(substance, getLabel);
    const requiredNumericQty = computeRequiredNumericQty(substance, totalTreatmentVolume);
    const requiredQty = computeRequiredWarehouseQty(warehouseUnit, requiredNumericQty);
    const usedTotal = drugBatchesCurrentDrug?.reduce(
      (sum, b) => sum + (Number(b.quantity) || 0),
      0
    );

    const stockStatusBySubstance = usedTotal >= requiredQty;
    setValue(
      `drug_batches.${isModifyMode}`,
      drugBatchesCurrentDrug?.map((b) => {
        return { ...b, is_enough_stock: stockStatusBySubstance };
      })
    );
    resetDrugBatchState();
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    resetDrugBatchState();
    setIsModalOpen(false);
  };

  const handleOpenModal = (modifyModeId = -1) => {
    clearErrors();
    setModifyMode(modifyModeId);
    const drugBatches = getValues("drug_batches") || [];
    if (isTreatment && drugBatches?.length > 0) {
      if (modifyModeId === -1) {
        reset({
          drug_batches_tmp: [],
        });
      } else if (modifyModeId > 0) {
        const tmp = substances?.find((cc) => cc.id === modifyModeId) || {};
        const substance = { ...tmp, drug_batches: drugBatches?.[modifyModeId] || [] };
        const groupedTreatmentsBySubstanceId = groupBySubstanceId([substance]); // trick to use operation?.treatments
        const d = groupedTreatmentsBySubstanceId?.[0] || null;
        if (d && (d?.drug_batches || [])?.length > 0) {
          setValue("drug_batches_tmp", d?.drug_batches);
        }
      }
    }
    setIsModalOpen(true);
  };

  const renderList = () => {
    const type = substanceType === "substance" ? "treatment" : substanceType;
    // group treatments by functional
    const additionalData =
      type === "treatment"
        ? groupByIngredientField(allSubstances, "functional", getLabel)
        : allSubstances;

    if ((!isProtocolApplication ? substances : tableData)?.length > 0) {
      return (
        <div className="substances_list_wrapper">
          {isTreatment && isProtocolApplication && (
            <div className="automatic_lot_assignment">
              <Tooltip
                variant={"info"}
                html={getLabel("treatmentAssignDrugBatchesTooltip")}
                place="right"
                events={["hover"]}
              >
                <CTA
                  // customClassName={"dialog confirm"}
                  isRed={false}
                  onClick={() => assignDrugBatches(substances, totalTreatmentVolume, automaticDrugBatches, getLabel, null, true, setValue)}
                >
                  {getLabel("treatmentAssignDrugBatches")}
                </CTA>
              </Tooltip>
            </div>
          )}
          <div className="substances_list_table">
            <TableEdit
              defaultData={
                !isProtocolApplication
                  ? substances?.map((s, i) => ({ ...s, index: i }))
                  : tableData
              }
              columns={columns}
              isSearchBar={isSearchBar}
              rowClickHandler={
                !isProtocolApplication
                  ? (row) => {
                      navigate(`/substances/${type}/${row.original.id}`);
                    }
                  : null
              }
              additionalData={additionalData}
              isEditable={true}
              isLegend={false}
              errors={errors}
              control={control}
              setValue={setValue}
              getValues={getValues}
              type={type}
              modalHandler={handleOpenModal}
              totalVolume={totalTreatmentVolume}
            />

            {isTreatment && (
              <div className="confirmation_wrapper">
                <ConfirmationModal
                  isOpen={isModalOpen}
                  onConfirm={handleConfirmModal}
                  onClose={handleCloseModal}
                  description={getLabel("modalConfigureDrugBatchDescription")}
                  isOperationRecap={true}
                  totalStep={0}
                  errors={errors}
                  getValues={getValues}
                  // configs={configs}
                >
                  <OperationRecap
                    id={operation_id || null}
                    type={"NEW_DRUG_BATCH"}
                    configs={configs}
                    control={control}
                    register={register}
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    // units={units}
                    arrayFields={drugBatches}
                    additionalData={tableData?.find(
                      (s) => s?.substance_id === isModifyMode
                    )}
                    additionalSubtype={totalTreatmentVolume}
                  />
                </ConfirmationModal>
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  const renderGrid = () => {
    const type = substanceType === "substance" ? "treatment" : substanceType;
    if (substances?.length > 0) {
      return (
        // <div className="substances_list_table">
        //   <TableEdit
        //     isMobile={isMobile || displayModeGrid}
        //     defaultData={
        //       !isProtocolApplication
        //         ? substances?.map((s, i) => ({ ...s, index: i }))
        //         : tableData
        //     }
        //     columns={columns}
        //     isSearchBar={isSearchBar}
        //     rowClickHandler={
        //       !isProtocolApplication
        //         ? (row) => {
        //             navigate(`/substances/${type}/${row.original.id}`);
        //           }
        //         : null
        //     }
        //     additionalData={filterAdditionalSubstances()?.sort((a, b) => a?.substance_name - b?.substance_name)}
        //     isEditable={true}
        //     isLegend={false}
        //     errors={errors}
        //     control={control}
        //     setValue={setValue}
        //     getValues={getValues}
        //     type={"substance"}
        //   />
        // </div>
        <div className="substances_grid">
          {substances?.map((substance) => {
            return <ProtocolTile substance={substance} type={"SUBSTANCES"} />;
          })}
        </div>
      );
    }
  };

  return (
    <div className="substances_list">
      {substances?.length > 0 && (
        <>
          {!isProtocolApplication && !isMobile && (
            <Switch
              leftOption={{
                label: getLabel("listView"),
              }}
              rightOption={{
                label: getLabel("listView"),
              }}
              toggleHandler={toggleDisplayMode}
              status={displayModeGrid}
            />
          )}
          {isMobile
            ? renderGrid()
            : displayModeGrid
            ? renderGrid()
            : renderList()}
        </>
      )}
      {!substances ||
        (substances?.length === 0 && (
          <>
            <div className="substances_alert">
              <h6 className="substances_alert_title">
                {getLabel("noSubstancesAlert", {
                  type:
                    substanceType === "analysis"
                      ? getLabel("exam")
                      : getLabel(substanceType),
                })}
              </h6>
            </div>
          </>
        ))}
    </div>
  );
};

export default SubstanceList;
